import { TOKEN_KEY } from "@/lib/api";

// Estatísticas anônimas do site: um id aleatório por navegador, sem nome ou telefone.
// Quem está logado na área do lojista neste aparelho não é contado.
const VID_KEY = "rc_vid";
const URL = `${process.env.REACT_APP_BACKEND_URL}/api/track`;

const vid = () => {
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(VID_KEY, v);
  }
  return v;
};

export const track = (type, data = {}) => {
  try {
    if (!process.env.REACT_APP_BACKEND_URL || localStorage.getItem(TOKEN_KEY)) return;
    fetch(URL, { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ type, vid: vid(), ...data }) }).catch(() => null);
  } catch {
    // Estatística nunca pode atrapalhar o site.
  }
};

const once = (key, fn) => {
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  fn();
};

export const trackVisit = () => once("rc_visit", () => track("visit"));
export const trackView = (p) => p?.id && once(`rc_view_${p.id}`, () => track("view", { product_id: p.id, model: String(p.model || "").slice(0, 80) }));

const SOURCES = [
  [/^(product-interest-btn-|sticky-buy-interest|interest-send|interest-only-iphone)/, "aparelho"],
  [/^featured-whatsapp-btn/, "oferta"],
  [/^simulator-whatsapp-button/, "simulador"],
  [/^cart-checkout-whatsapp/, "carrinho"],
  [/^(header-whatsapp-button|floating-whatsapp-btn|contact-whatsapp-button|hero-cta-whatsapp)/, "geral"],
];
const sourceOf = (testid = "") => SOURCES.find(([re]) => re.test(testid))?.[1] || "outros";

// Conta todo clique que realmente abre o WhatsApp (cliques cancelados, como o que abre a escolha de acessórios, não contam).
export const installContactTracking = () => {
  const onClick = (e) => {
    const a = e.target?.closest?.('a[href*="wa.me"]');
    if (!a || e.defaultPrevented) return;
    const { pid, pmodel } = a.dataset;
    track("contact", { source: sourceOf(a.dataset.testid), ...(pid ? { product_id: pid.slice(0, 40), model: String(pmodel || "").slice(0, 80) } : {}) });
  };
  document.addEventListener("click", onClick);
  return () => document.removeEventListener("click", onClick);
};
